import {
	GET_MY_TEAM_ROOMS,
	GET_MY_TEAM_ROOMS_SUCCESS,
	GET_MY_TEAM_ROOMS_FAILURE,
	ADD_MY_TEAM_ROOM,
	DELETE_MY_TEAM_ROOM,
	DELETE_MY_TEAM_ROOM_SUCCESS,
	SHARE_SNAP,
	LOAD_MORE_MY_TEAM_ROOMS,
	LOAD_MORE_MY_TEAM_ROOMS_SUCCESS,
} from './types';

export const getMineTeamRoomsAction = () => ({
	type: GET_MY_TEAM_ROOMS,
});

export const getMineTeamRoomsSuccessAction = (payload: any) => ({
	type: GET_MY_TEAM_ROOMS_SUCCESS,
	payload,
});

export const getMineTeamRoomsFailureAction = (error: Error) => ({
	type: GET_MY_TEAM_ROOMS_FAILURE,
	payload: error,
});

export const addMineTeamRoomAction = (payload: any) => ({
	type: ADD_MY_TEAM_ROOM,
	payload,
});

export const deleteMineTeamRoomAction = (payload: any) => ({
	type: DELETE_MY_TEAM_ROOM,
	payload,
});

export const deleteMineTeamRoomSuccessAction = (payload: any) => ({
	type: DELETE_MY_TEAM_ROOM_SUCCESS,
	payload,
});

export const shareSnapAction = (payload: any) => ({
	type: SHARE_SNAP,
	payload,
});

export const loadMoreMineTeamRoomsAction = (payload: any) => ({
	type: LOAD_MORE_MY_TEAM_ROOMS,
	payload,
});

export const loadMoreMineTeamRoomsSuccesAction = (payload: any) => ({
	type: LOAD_MORE_MY_TEAM_ROOMS_SUCCESS,
	payload,
});
